import { supabase } from '@/lib/supabaseClient';

/**
 * Баланс кредитов.
 *
 * Читается из user_credits — материализованного агрегата, который меняет
 * только серверная функция вместе с записью в credit_transactions. Клиент
 * не складывает журнал сам и ничего не списывает: он показывает число,
 * а решают всё серверные проверки при создании генерации.
 *
 * RLS отдаёт только собственную строку, поэтому фильтр по user_id здесь
 * не нужен — как и в остальных клиентских запросах.
 */
export async function fetchCreditBalance(): Promise<number> {
  if (!supabase) {
    return 0;
  }

  const { data, error } = await supabase.from('user_credits').select('balance').maybeSingle();

  if (error) {
    throw new Error('Не удалось узнать остаток кредитов.');
  }

  // Строки может не быть у совсем нового пользователя — это не ошибка,
  // а ноль: начисление придёт стартовой серверной функцией.
  return (data as { balance: number } | null)?.balance ?? 0;
}
